export default function isInsideEurope(lat, lng) {
  // Coordinates for the bounds of Europe
  const minLat = 34.9;
  const maxLat = 71.4;
  const minLng = -23.35;
  const maxLng = 40.5;

  // Check if the latitude and longitude are within the bounds
  if (lat >= minLat && lat <= maxLat && lng >= minLng && lng <= maxLng) {
    return true;
  }

  return false;
}
